import type { SessionDetailLocationState } from './session-detail.type';

/** Where Back goes when the page was not opened with a `returnTo`. */
const SESSION_DETAIL_DEFAULT_BACK_PATH = '/application/agent-miner';

/**
 * Resolves the session detail page's Back target from router state. Only
 * in-app `/application/...` paths are honoured, since router state can be
 * set by any caller; anything else falls back to the Agent Miner sessions list.
 *
 * @param {unknown} state - `location.state` from React Router
 * @returns {string} The path the Back button should navigate to
 */
const resolveSessionDetailBackPath = (state: unknown): string => {
  const returnTo = (state as SessionDetailLocationState | null)?.returnTo;
  if (typeof returnTo === 'string' && returnTo.startsWith('/application/')) return returnTo;
  return SESSION_DETAIL_DEFAULT_BACK_PATH;
};

export { resolveSessionDetailBackPath, SESSION_DETAIL_DEFAULT_BACK_PATH };
